import {Component, OnInit} from '@angular/core';
import {AuthService} from './services/auth.service';
import {NavController, Platform} from '@ionic/angular';
import { GoogleAuth } from '@codetrix-studio/capacitor-google-auth';
import { App } from '@capacitor/app';
import {environment} from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
  showStartup = true;
  isMobile = false;
  isAndroid = false;

  constructor(
    private auth: AuthService,
    private platform: Platform,
    private navCtrl: NavController
  ) {
    this.initializeApp();
    if (environment.implementation !== 'web') {
      this.isMobile = true;
      if (environment.implementation === 'android') {
        this.isAndroid = true;
        this.showStartup = false;
      }
    }
  }

  ngOnInit() {
    setTimeout(() => {
      this.showStartup = false;
    }, 3200);
    if (environment.implementation !== 'web') {
      App.addListener('appUrlOpen', data => {
        if (data.url.indexOf('validationcode') > -1) {
          const startIndex = data.url.indexOf('validationcode=');
          const validationCode = data.url.substring(startIndex + 15, data.url.length)
          if (validationCode && validationCode.length > 0) {
            this.navCtrl.navigateRoot('/tabs/ride', {queryParams: {validationcode: validationCode}});
          }
        } else if (data.url.indexOf('/n/') > -1) {
          const urlList = data.url.split('/');
          this.navCtrl.navigateForward('/n/' + urlList[urlList.length - 1]);
        }
      });
    }
  }

  initializeApp() {
    this.platform.ready().then(() => {
      GoogleAuth.initialize({
        clientId: '139595443362-tltlkhb8nbr00fbiscrfhh24msolf9cp.apps.googleusercontent.com',
        scopes: ['profile', 'email'],
        grantOfflineAccess: true,
      });
    });
  }
}
